(function(){
  function move(){
    var els=document.querySelectorAll('[data-arv-move]');
    for(var i=0;i<els.length;i++){
      var el=els[i],v=el.getAttribute('data-arv-move'),c=v.indexOf(':');
      if(c<0)continue;
      var pos=v.slice(0,c),t=document.querySelector(v.slice(c+1));
      if(!t||!t.parentNode)continue;
      t.parentNode.insertBefore(el,pos==='before'?t:t.nextSibling);
      el.removeAttribute('data-arv-move');
    }
  }
  function reveal(){
    if(!('IntersectionObserver' in window))return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(document.documentElement.classList.contains('shopify-design-mode'))return;
    var els=[].slice.call(document.querySelectorAll('[data-arv-reveal]'));
    if(!els.length)return;
    var vh=window.innerHeight||800;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('arv-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -6% 0px',threshold:0.06});
    els.forEach(function(el){var r=el.getBoundingClientRect();if(r.top<vh*0.95){el.classList.add('arv-in');}else{io.observe(el);}});
    document.documentElement.classList.add('arv-motion');
  }
  function init(){try{move();}catch(e){}try{reveal();}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
